import "./ServiceNav.scss";
import React from "react";



const ServiceNav = ({label, children}: {label: string} & React.PropsWithChildren) => {
    const enhancedChildren = React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                className: "item",
                key: child.key || `child-${index}`
            });
        }
        return child;
    });
    return <div className={"main-nav"}>
        <div className={"nav"}>
            <div className={"label"}>{label}</div>
            {enhancedChildren}
        </div>
    </div>
}

export default ServiceNav;
export {ServiceNav}